import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref, computed, onBeforeMount, inject } from "vue";
import { Field } from "vee-validate";
import InlineSvg from "vue-inline-svg";
import { useSurveyStore } from "@/stores/surveyStore";
import { PROVIDE_KEY_SHOW_ERROR_MODAL, ShowErrorModal } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSelect',
  props: {
  label: {
    type: String,
  },
  name: {
    type: String,
    required: true,
  },
  value: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "선택하세요",
  },
  items: {
    type: Array as PropType<{ [key: string]: string | string[] }[] | string[]>,
    // required: true,
  },
  itemValue: {
    type: String,
    // required: true,
  },
  itemText: {
    type: String,
    // required: true,
  },
  datasource: {
    type: String,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  lineSurveyId: {
    type: String,
    default: "",
  },
},
  emits: ["onChangeSelect", "update:value", "onReceivedEmptyTargetLines"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const surveyStore = useSurveyStore();

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;

const inputValue = computed({
  get() {
    return props.value;
  },
  set(inputValue) {
    emit("update:value", inputValue);
  },
});
const options = ref();

const optionValue = (option: { [key: string]: string | string[] } | string) => {
  if (typeof option === "string") {
    return option;
  }
  return props.itemValue ? option[props.itemValue] : option;
};
const optionText = (option: { [key: string]: string | string[] } | string) => {
  if (typeof option === "string") {
    return option;
  }
  return props.itemText ? option[props.itemText] : option;
};

const onChangeSelect = (event: Event) => {
  const selectElement = event.target as HTMLSelectElement;
  emit("update:value", selectElement.value);
  emit("onChangeSelect", selectElement.value);
};

const getDatasource = async () => {
  switch (props.datasource) {
    case "/target-line": {
      const surveyTargetLinesResult = await surveyStore.getSurveyTargetLines(
        props.lineSurveyId
      );
      if (!surveyTargetLinesResult.isSuccess) {
        showErrorModal(
          "평가노선 오류",
          surveyTargetLinesResult.errorMessage,
          surveyTargetLinesResult.resultCode,
          surveyTargetLinesResult.errorTime
        );
        return;
      }
      if (!surveyTargetLinesResult.data?.length) {
        emit("onReceivedEmptyTargetLines");
        return;
      }
      return surveyTargetLinesResult?.data ?? [];
    }
    default:
      return [];
  }
};

onBeforeMount(async () => {
  if (!props.items && props.datasource) {
    options.value = await getDatasource();
    return;
  }
  options.value = props.items;
});

const __returned__ = { props, emit, surveyStore, showErrorModal, inputValue, options, optionValue, optionText, onChangeSelect, getDatasource, get Field() { return Field }, get InlineSvg() { return InlineSvg } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})